import archiveFilter from "./../archiveFilters";

export default {
  init() {
    var common = this;
    // JavaScript to be fired on all pages
    this.initQuickSearch();
    this.initQuickShop();
    this.initStickyHeader();
    this.initHeaderSearch();
    this.initScrollToAnchor();
    this.initModals();

    if ($(".woocommerce-products-header-custom-filters").length > 0) {
      archiveFilter.initArchiveFilter();
    }

    $("body").on("click", (e) => {
      if (jQuery(".ep-autosuggest").is(":visible")) {
        let isClickOutsideOfAutosuggest =
          $(".ep-autosuggest").find(e.srcElement).length === 0;

        if (
          isClickOutsideOfAutosuggest &&
          epasAPI.hasOwnProperty("hideAutosuggestBox")
        ) {
          epasAPI.hideAutosuggestBox();
        }
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  initModals() {
    $('[href="/nl_signup"]').click(function (e) {
      e.preventDefault();
      // todo - move to ajax when ajax works
      $.get(
        "/wp-content/themes/current/resources/ajax/mailchimp-signup.html",
        function (data) {
          $("#nl-modal .modal-body").html(data);
          console.log("Load was performed.", data);
          $("#nl-modal").modal("show");
        }
      );
    });
  },
  initQuickSearch() {
    $(".quick-shop-search-field-sku").keyup((event) => {
      let inputValue = event.target.value;
      // console.log(event);
      if (inputValue.length > 2) {
        // 285187 => 61
        getProducts(inputValue);
      }
    });

    function getProducts(search) {
      console.log(search);
      let data = {
        action: "my_action",
        search: search,
      };
      // We can also pass the url value separately from ajaxurl for front end AJAX implementations
      jQuery.post(admin_url.ajax_url, data, function (response) {
        console.log(response);
      });
    }
  },
  initHeaderSearch() {
    $("[href=#headerSearch]").click(function (e) {
      e.preventDefault();
      var searchBtn = $(this);
      var searchContainer = $(".js-header-search");
      searchContainer.toggleClass("active");
      if (searchContainer.hasClass("active")) {
        searchBtn.find("i").addClass("icon-close").removeClass("icon-search");
        searchContainer.find(".s").focus();
      } else {
        searchBtn.find("i").removeClass("icon-close").addClass("icon-search");
      }
    });

    if ($('[data-toggle="tooltip"]').length > 0) {
      $('[data-toggle="tooltip"]').tooltip();
    }
  },
  initQuickShop() {
    $(".quick-cart__btn-close").on("click", (event) => {
      console.log(event, $(".menu-item.menu-cart"));
      $(".menu-item.menu-cart.quick-shop-active").removeClass(
        "quick-shop-active"
      );
    });

    $("body").on("click", (e) => {
      // close quickshop if click is registered outside of it
      if (jQuery(".menu-cart").is(":visible")) {
        let isClickInsideOfQuickCart =
          $(".menu-cart").find(e.srcElement).length > 0;

        if (!isClickInsideOfQuickCart) {
          $(".menu-item.menu-cart").removeClass("quick-shop-active");
        }
      }
    });
  },
  initStickyHeader() {
    var sticky_container = document.getElementById("sticky-header-container");
    var mmenu = document.getElementById("js-cat-mmenu");
    // Get the offset position of the navbar

    if ($("#sticky-header-container").length > 0) {
      var sticky = sticky_container.offsetHeight * 0.6;
      window.onscroll = function () {
        if (window.pageYOffset > sticky) {
          sticky_container.classList.add("sticky");
          mmenu.classList.add("sticky");
        } else {
          sticky_container.classList.remove("sticky");
          mmenu.classList.remove("sticky");
        }
      };
    }
  },
  // scroll to ID in data-target
  initScrollToAnchor() {
    if ($(".js-scroll-to-anchor").length > 0) {
      $(".js-scroll-to-anchor")
        .off("click")
        .on("click", function (e) {
          e.preventDefault();
          let target = $("#" + $(this).data("target")); // use ID in data-target
          $("html, body").animate(
            { scrollTop: target.offset().top - 200 },
            500
          );
        });
    }
    $(".js-scroll-to").click(function (e) {
      e.preventDefault();
      var target = $($(this).attr("href"));
      $("body,html").animate(
        {
          scrollTop: target.offset().top,
        },
        300
      );
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js